import _ from "lodash";
import { VAR_TYPES } from "constants/constants";
import { getFormattedDate } from "./functions";

export const backupManagerForm = ({ personsList }) => [
  {
    col: "establishment_date",
    type: VAR_TYPES.DATE,
    mandatory: true,
    isMissingValue: null,
  },
  {
    col: "establishment_date_end",
    type: VAR_TYPES.DATE,
    mandatory: true,
    isMissingValue: null,
  },
  {
    col: "backed_manager_id",
    isMissingValue: null,
    editable: true,
    popup: {
      title: {
        id: "admin_country_page_table_name_dsoc_search",
        defaultMessage: "Recherche et sélectionne un responsable",
      },
    },
    mandatory: true,
    type: VAR_TYPES.SEARCH,
    choices: personsList?.map((elm) => ({
      value: elm?.id,
      label: `${elm?.first_name} ${elm?.last_name}`,
    })),
    search: true,
  },
  {
    col: "backup_manager_id",
    isMissingValue: null,
    editable: true,
    popup: {
      title: {
        id: "admin_country_page_table_name_dsoc_search",
        defaultMessage: "Recherche et sélectionne un responsable",
      },
    },
    mandatory: true,
    type: VAR_TYPES.SEARCH,
    choices: personsList?.map((elm) => ({
      value: elm?.id,
      label: `${elm?.first_name} ${elm?.last_name}`,
    })),
    search: true,
  },
];

export const formatPayload = (payload) => ({
  ...payload,
  backed_manager_id: payload?.backed_manager_id[0]?.value,
  backup_manager_id: payload?.backup_manager_id[0]?.value,
});

export const formatReceivedBackupManager = ({
  backupManager,
  personsList,
  lang,
}) => ({
  id: backupManager.id,
  backed_manager_id: personsList
    .filter((elm) => elm.id === backupManager?.backed_manager_id)
    ?.map((elm) => `${elm?.first_name} ${elm?.last_name}`)[0],
  backup_manager_id: personsList
    .filter((elm) => elm.id === backupManager?.backup_manager_id)
    ?.map((elm) => `${elm?.first_name} ${elm?.last_name}`)[0],
  establishment_date: getFormattedDate(backupManager.establishment_date, lang),
  establishment_date_end: getFormattedDate(
    backupManager.establishment_date_end,
    lang
  ),
});
export const formatReceivedBackupManagerToEdit = ({
  backupManager,
  personsList,
}) => ({
  id: backupManager.id,
  backed_manager_id: personsList
    .filter((elm) => elm.id === backupManager?.backed_manager_id)
    ?.map((elm) => ({
      label: `${elm?.first_name} ${elm?.last_name}`,
      value: elm?.id,
    })),
  backup_manager_id: personsList
    .filter((elm) => elm.id === backupManager?.backup_manager_id)
    ?.map((elm) => ({
      label: `${elm?.first_name} ${elm?.last_name}`,
      value: elm?.id,
    })),
  establishment_date: backupManager.establishment_date,
  establishment_date_end: backupManager.establishment_date_end,
});

export const formatReceivedBackupManagers = ({
  backupManagerList,
  personsList,
  lang,
}) =>
  backupManagerList.map((elm) => ({
    ...elm,
    backed_manager_id: getPersonName({
      personsList,
      id: elm.backed_manager_id,
    }),
    backup_manager_id: getPersonName({
      personsList,
      id: elm.backup_manager_id,
    }),
    establishment_date: getFormattedDate(elm?.establishment_date, lang),
    establishment_date_end: getFormattedDate(elm?.establishment_date_end, lang),
  }));

const getPersonName = ({ personsList, id }) =>
  _.chain(personsList)
    .filter((elm) => elm.id === id)
    .map((elm) => `${elm?.first_name} ${elm?.last_name}`)
    .first()
    .value();
